import { GAME_SYMBOLS } from "@/app/constants.mjs";
import type { GameSymbol } from "@/app/games.mjs";
import gamesList from "@/app/games.mjs";
import comingSoonRoutes from "@/routes/coming-soon.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import SymbolMap from "@/util/symbol-map.mjs";

// The categorization by game routes is used for showing the correct context
// in the app, most notably the app navigation.
const gameRoutes = new SymbolMap({
  ...GAME_SYMBOLS.reduce((h, gameSymbol) => {
    h[gameSymbol] = [];
    return h;
  }, {}),

  ...gamesList.reduce((obj, { gameSymbol, routes }) => {
    if (Object.hasOwn(comingSoonRoutes, gameSymbol)) {
      routes.push(...comingSoonRoutes[gameSymbol]);
    }

    obj[gameSymbol] = routes;
    return obj;
  }, {}),
} as Record<GameSymbol, BaseRoute[]>);
export default gameRoutes;
